(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Catalogue live search: predictive results drop down as you type,
  // via Shopify's suggest endpoint. Enter goes to the full search page.
  document.querySelectorAll('[data-live-search]').forEach((root) => {
    const input = root.querySelector('input');
    const panel = root.querySelector('.collection__livesearch-panel');
    const status = root.querySelector('[data-live-search-status]');
    if (!input || !panel) return;
    let controller = null;
    let timer = null;

    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function esc(s) {
      const d = document.createElement('div');
      d.textContent = s;
      return d.innerHTML;
    }

    function thumb(p) {
      const url = p.featured_image && p.featured_image.url;
      if (!url) return '';
      const sized = url + (url.includes('?') ? '&' : '?') + 'width=80';
      return '<img src="' + sized + '" alt="" width="40" height="56" loading="lazy">';
    }

    function render(products, q) {
      if (!products.length) {
        panel.innerHTML =
          '<span class="collection__livesearch-empty">Nothing matched "' + esc(q) + '"</span>';
      } else {
        panel.innerHTML =
          products
            .map((p) => {
              const parts = p.title.split(' - ');
              const name = parts.shift();
              return (
                '<a class="collection__livesearch-row" href="' + p.url + '">' +
                thumb(p) +
                '<span><span class="collection__livesearch-name">' + esc(name) + '</span>' +
                (parts.length
                  ? '<br><span class="collection__livesearch-meta">' + esc(parts.join(' · ')) + '</span>'
                  : '') +
                '</span></a>'
              );
            })
            .join('') +
          '<a class="collection__livesearch-all" href="/search?q=' + encodeURIComponent(q) + '">' +
          'See all results</a>';
      }
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      if (status) {
        status.textContent = products.length + (products.length === 1 ? ' result' : ' results');
      }
    }

    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(timer);
      if (controller) controller.abort();
      if (q.length < 2) {
        close();
        return;
      }
      timer = setTimeout(async () => {
        controller = new AbortController();
        try {
          const res = await fetch(
            '/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=8' +
              '&resources[options][unavailable_products]=hide',
            { signal: controller.signal }
          );
          const data = await res.json();
          render((data.resources.results.products || []), q);
        } catch (e) {
          /* aborted mid-type or offline — stay quiet */
        }
      }, 220);
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        close();
        input.blur();
      } else if (e.key === 'Enter') {
        const q = input.value.trim();
        if (q) window.location.href = '/search?q=' + encodeURIComponent(q);
      }
    });

    document.addEventListener('click', (e) => {
      if (!root.contains(e.target)) close();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-jp-cycle]').forEach((cycle) => {
    const pages = Array.from(cycle.children);
    if (pages.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    pages.forEach((p, i) => { p.inert = i !== 0; });
    // Warm the second page so its images are loaded before the first cycle.
    if (pages[1]) pages[1].hidden = false;

    let idx = 0;
    let paused = false;
    let visible = true;

    function advance() {
      if (paused || !visible) return;
      const current = pages[idx];
      idx = (idx + 1) % pages.length;
      const next = pages[idx];
      next.hidden = false;
      // Warm the page after this one too, one interval ahead of need.
      pages[(idx + 1) % pages.length].hidden = false;
      void next.offsetWidth; // commit the unhide so the transition runs
      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      current.inert = true;
      next.classList.add('is-active');
      next.inert = false;
      setTimeout(() => current.classList.remove('is-leaving'), 700);
    }

    const interval = Math.max(2000, Number(cycle.dataset.interval) || 5000);
    setInterval(advance, interval);

    cycle.addEventListener('pointerenter', () => { paused = true; });
    cycle.addEventListener('pointerleave', () => { paused = false; });
    cycle.addEventListener('focusin', () => { paused = true; });
    cycle.addEventListener('focusout', () => { paused = false; });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        visible = entries[0].isIntersecting;
      }).observe(cycle);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
